var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('strong', [_vm._v("Made with")]), _vm._v(" ❤️ by "), _c('a', {
    attrs: {
      "href": "http://vinayak.website",
      "target": "_blank"
    }
  }, [_vm._v("Vinayak")]), _vm._v(". The source code is licensed\n        "), _c('a', {
    attrs: {
      "href": "http://opensource.org/licenses/mit-license.php"
    }
  }, [_vm._v("MIT")]), _vm._v(".\n      ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "icon",
    attrs: {
      "href": "https://github.com/vinayakkulkarni/poll"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a2b4a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1rrJ
// module chunks = 1